import {
  activeDirectoryApi,
  adminFormsApi,
  appConfigApi,
  approvalWorkflowApi,
  backdatingApi,
  baselineDateApi,
  commentApi,
  conditionalAccessApi,
  dashboardApi,
  dynamicFieldApi,
  formsApi,
  historyApi,
  initiativesApi,
  issuesApi,
  keyMilestonesApi,
  projectIssueCategoriesApi,
  projectIssueStatusesApi,
  milestoneTemplateApi,
  notificationGroupApi,
  permissionsApi,
  projectApi,
  projectApprovalApi,
  projectImageApi,
  projectRoleApi,
  projectTemplateApi,
  projectRisksApi,
  projectRiskCategoriesApi,
  projectImpactAreasApi,
  projectRiskStatusesApi,
  storageApi,
  userApi,
  userReplacementApi,
  ctqSnapshotApi,
} from "@/services";
import { projectMilestoneDocumentApi } from "@/services/projectMilestoneDocument";
import { applicationErrorSlice } from "@/store/slices";
import * as Locales from "./Locales";

export const rootReducer = {
  locales: Locales.reducer,
  [activeDirectoryApi.reducerPath]: activeDirectoryApi.reducer,
  [adminFormsApi.reducerPath]: adminFormsApi.reducer,
  [applicationErrorSlice.name]: applicationErrorSlice.reducer,
  [approvalWorkflowApi.reducerPath]: approvalWorkflowApi.reducer,
  [baselineDateApi.reducerPath]: baselineDateApi.reducer,
  [commentApi.reducerPath]: commentApi.reducer,
  [conditionalAccessApi.reducerPath]: conditionalAccessApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [notificationGroupApi.reducerPath]: notificationGroupApi.reducer,
  [formsApi.reducerPath]: formsApi.reducer,
  [milestoneTemplateApi.reducerPath]: milestoneTemplateApi.reducer,
  [projectApi.reducerPath]: projectApi.reducer,
  [projectApprovalApi.reducerPath]: projectApprovalApi.reducer,
  [projectImageApi.reducerPath]: projectImageApi.reducer,
  [projectMilestoneDocumentApi.reducerPath]:
    projectMilestoneDocumentApi.reducer,
  [projectRoleApi.reducerPath]: projectRoleApi.reducer,
  [permissionsApi.reducerPath]: permissionsApi.reducer,
  [projectTemplateApi.reducerPath]: projectTemplateApi.reducer,
  [storageApi.reducerPath]: storageApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [dynamicFieldApi.reducerPath]: dynamicFieldApi.reducer,
  [historyApi.reducerPath]: historyApi.reducer,
  [initiativesApi.reducerPath]: initiativesApi.reducer,
  [issuesApi.reducerPath]: issuesApi.reducer,
  [projectIssueCategoriesApi.reducerPath]: projectIssueCategoriesApi.reducer,
  [projectIssueStatusesApi.reducerPath]: projectIssueStatusesApi.reducer,
  [projectRisksApi.reducerPath]: projectRisksApi.reducer,
  [projectRiskCategoriesApi.reducerPath]: projectRiskCategoriesApi.reducer,
  [projectImpactAreasApi.reducerPath]: projectImpactAreasApi.reducer,
  [projectRiskStatusesApi.reducerPath]: projectRiskStatusesApi.reducer,
  [appConfigApi.reducerPath]: appConfigApi.reducer,
  [backdatingApi.reducerPath]: backdatingApi.reducer,
  [userReplacementApi.reducerPath]: userReplacementApi.reducer,
  [ctqSnapshotApi.reducerPath]: ctqSnapshotApi.reducer,
  [keyMilestonesApi.reducerPath]: keyMilestonesApi.reducer,
};
